import React, { FC, useContext } from 'react';

import { SettingsBlock, SettingsFrame } from 'components';
import { LocalizationContext } from 'localization';

import { FeatureHOC } from '../../../../../features';
import {
  Blacklist,
  ChromeDownloadRestrict,
  DiscManager,
  HighPassword,
  RemoteControl,
  RemovableStorage,
  WatchChangedConfig,
} from './components';

export const SecurityTab: FC = () => {
  const { t } = useContext(LocalizationContext);
  return (
    <SettingsBlock title={t('settings.tabs.security')}>
      <SettingsFrame>
        <HighPassword />
      </SettingsFrame>

      <SettingsFrame>
        <RemoteControl />
      </SettingsFrame>

      <SettingsFrame>
        <DiscManager />
      </SettingsFrame>

      <SettingsFrame>
        <RemovableStorage />
      </SettingsFrame>

      <SettingsFrame>
        <ChromeDownloadRestrict />
      </SettingsFrame>

      <SettingsFrame>
        <Blacklist />
      </SettingsFrame>

      <FeatureHOC alias="host_hardware" strategy="hide">
        <SettingsFrame>
          <WatchChangedConfig />
        </SettingsFrame>
      </FeatureHOC>
    </SettingsBlock>
  );
};
